import { Button, Flex, Typography } from "antd"

export const KybStepUi = () => {
  return (
    <Typography.Text>
      If you haven't completed KYB yet, you need to do so to start using our
      service. Click the "Go through KYB" button to fill out the required form.
    </Typography.Text>
  )
}
